import {
  RefSelectProps,
  Select as _Select,
  SelectProps as _SelectProps,
} from 'antd'
import { Icon } from 'shared/iconpack'

import { forwardRef } from 'react'

import { palette } from 'shared/config/styles/palette'

import './Select.css'

export type SelectProps = _SelectProps & {
  withPlaceholder?: boolean
  suffixClassname?: string
}

export const Select = forwardRef<RefSelectProps, SelectProps>(
  (
    {
      className,
      withPlaceholder = true,
      placeholder,
      suffixIcon,
      suffixClassname,
      ...props
    }: SelectProps,
    ref,
  ) => {
    return (
      <_Select
        ref={ref}
        placeholder={withPlaceholder ? placeholder : ''}
        className={`customSelect ${className}`}
        suffixIcon={
          suffixIcon || (
            <div
              className={`flex items-center mb-[-3px] mr-[-3px] ${suffixClassname}`}
            >
              <Icon
                name="arrowDown"
                width={21}
                height={20}
                color={palette.dark}
              />
            </div>
          )
        }
        {...props}
      />
    )
  },
)

export const SelectOption = _Select.Option
